import { gql } from "@apollo/client";

const RENTAL_HISTORY_FIELDS = `
  id
  propertyId
  surveyDate
  data
  createdAt
  updatedAt
`;

const GET_RENTAL_HISTORY = gql`
  query rentalHistory($id: ID!) {
    rentalHistory(id: $id) {
      ${RENTAL_HISTORY_FIELDS}
    }
  }
`;

const GET_RENTAL_HISTORIES = gql`
  query rentalHistories($input: RentalHistoriesInput!) {
    rentalHistories(input: $input) {
      total
      rentalHistories {
        ${RENTAL_HISTORY_FIELDS}
      }
    }
  }
`;

export { GET_RENTAL_HISTORY, GET_RENTAL_HISTORIES, RENTAL_HISTORY_FIELDS };
